import React from 'react';
import PropTypes from 'prop-types';

export function FacilityUnitMicroData({
	storageUnits,
	vehicleUnits,
	facilityName,
	facilityUrl,
	facilityImageUrl,
	facilityId,
}) {
	const createProductSchemas = () => {
		const schemas = [];

		storageUnits.forEach((unit) => {
			schemas.push({
				'@context': 'https://schema.org',
				'@type': 'Product',
				'@id': facilityId,
				name: facilityName,
				description: `${unit.sizeText} Storage Unit - ${facilityName}`,
				productID: facilityId,
				url: facilityUrl,
				brand: {
					'@type': 'Brand',
					name: facilityName,
				},
				offers: {
					'@type': 'Offer',
					price: unit.price.value,
					priceCurrency: 'USD',
					availability: 'https://schema.org/InStock',
				},
				image: facilityImageUrl,
			});
		});

		vehicleUnits.forEach((unit) => {
			schemas.push({
				'@context': 'https://schema.org',
				'@type': 'Product',
				'@id': facilityId,
				name: facilityName,
				description: `${unit.sizeText} Vehicle Storage - ${facilityName}`,
				productID: facilityId,
				url: facilityUrl,
				brand: {
					'@type': 'Brand',
					name: facilityName,
				},
				offers: {
					'@type': 'Offer',
					price: unit.price.value,
					priceCurrency: 'USD',
					availability: 'https://schema.org/InStock',
				},
				image: facilityImageUrl,
			});
		});

		return schemas;
	};

	const productSchemas = createProductSchemas();

	return (
		<>
			{productSchemas.map((schema, index) => (
				<script
					key={`${schema['@id']}-${index}`}
					type="application/ld+json"
				>
					{JSON.stringify(schema)}
				</script>
			))}
		</>
	);
}

FacilityUnitMicroData.propTypes = {
	storageUnits: PropTypes.arrayOf(
		PropTypes.shape({
			sizeText: PropTypes.string.isRequired,
			price: PropTypes.shape({
				value: PropTypes.number.isRequired,
			}).isRequired,
		})
	).isRequired,
	vehicleUnits: PropTypes.arrayOf(
		PropTypes.shape({
			sizeText: PropTypes.string.isRequired,
			price: PropTypes.shape({
				value: PropTypes.number.isRequired,
			}).isRequired,
		})
	).isRequired,
	facilityName: PropTypes.string.isRequired,
	facilityUrl: PropTypes.string.isRequired,
	facilityImageUrl: PropTypes.string.isRequired,
	facilityId: PropTypes.string.isRequired,
};
